import { render, staticRenderFns } from "./gptModal.vue?vue&type=template&id=350ad66a&"
import script from "./gptModal.vue?vue&type=script&lang=js&"
export * from "./gptModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports